export default {"src":"/_next/static/media/install.9612377b.svg","height":35,"width":45,"blurWidth":0,"blurHeight":0};